<template>
  <div>
    <div class="font-medium font-inter text-black" :class="[headingSize, headingPadding]">
      <span class="capitalize">{{ heading.toLowerCase() }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      default: 'Heading',
    },
    headingSize: {
      type: String,
      default: 'text-xl',
    },
    headingPadding: {
      type: String,
      default: 'py-5',
    },
  },
}
</script>
